import { User } from "@/types";
import { formatUserStatus } from "@/utils";
import { Chip } from "@mui/material";
import { FC } from "react";
import { sanitizeFieldRestProps, useRecordContext } from "react-admin";
import { chipColorByStatus } from "../utils";
import { StatusFieldProps } from "./status-field.types";

const StatusField: FC<StatusFieldProps> = (props) => {
  const user = useRecordContext<User>();

  if (!user) return null;

  return (
    <Chip
      size="small"
      variant="outlined"
      color={user.isDeleted ? "error" : chipColorByStatus(user.status)}
      label={user.isDeleted ? "Deleted" : formatUserStatus(user.status)}
      {...sanitizeFieldRestProps(props)}
    />
  );
};

export { StatusField };
